import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { Button } from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";

export default function ManagedGroupListEmpty({ onCreate }) {
  const { t } = useScriptMode();
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4">
      <GroupAddIcon sx={{ fontSize: 96 }} className="text-terakkiNeutral" />
      <div className="text-xl font-SemiBold text-terakkiPrimary text-center">
        {t("manage_empty_title")}
      </div>
      <div className="text-sm text-terakkiNeutral text-center max-w-sm">
        {t("manage_empty_body")}
      </div>
      <Button variant="contained" onClick={onCreate} sx={{ mt: 2 }}>
        {t("manage_empty_cta")}
      </Button>
    </div>
  );
}
